/**
 * Created by Jan Bradac on 4.8.2016.
 */

(function (Lfl, $, undefined) {

    (function (Events, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Events, 'ClickVsDragDistinguisher')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * A class that helps distinguish whether user action was a simple click or a real mouse drag.
         *
         * @memberOf Lfl.Events
         */
        Lfl.Events.ClickVsDragDistinguisher;

        (function (ClickVsDragDistinguisher, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */

            /**
             * The minimal distance the mouse must travel while being pressed down to be considered a drag.
             * @type {number}
             */
            var MIN_DISTANCE_TO_BE_DRAG = 10;

            /**
             * The time after which a mousedown is considered a drag regardless of whether the user actually moved his mouse.
             * @type {number}
             */
            var TIME_TO_BE_CONSIDERED_DRAG = 1000;

            var isCurrentBehaviourDrag = false;

            var $body = $('body');

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Registers an action that only gets fired if the user performs a click but not a drag.
             *
             * @memberOf Lfl.Events.ClickVsDragDistinguisher
             * @param {jQuery} parameters.$element
             * @param {function} parameters.action
             * @param {string} [parameters.actionName]
             * @return {string} The name under which the action was registered for later modifications.
             */
            ClickVsDragDistinguisher.registerOnClickButNotDragAction = function (parameters) {
                var $element = parameters.$element;
                var action = parameters.action;
                var actionName = parameters.actionName;
                
                if (typeof actionName === 'undefined') {
                    actionName = generateActionName();
                }

                var dragging = false;

                $element.on(generateEventName("mousedown", actionName), function (event) {
                    dragging = false;


                    // If it would become a drag, then we set "dragging" to true.
                    ClickVsDragDistinguisher.makeSureItIsDrag(
                        event,
                        function () {
                            dragging = true;
                        },
                        actionName + ".makeSureItIsDrag");

                    $element.on(generateEventName("mouseup", actionName), function (event) {
                        if (dragging === false) {
                            // The user released the mouse before it was a drag.
                            action(event);
                        } else {
                            // It was dragging, do nothing.
                        }

                        // Remove event listeners so that we don't waste resources
                        $element.off(generateEventName("mouseup", actionName));
                    });
                });


                return actionName;
            };


            /**
             * Performs the action only after it has been made sure that the action is not a click but a real drag.
             *
             * @memberOf Lfl.Events.ClickVsDragDistinguisher
             * @param event
             * @param {function} action
             * @param {string} [actionName]
             * @return {string} The name under which the action was registered for later modifications.
             */
            ClickVsDragDistinguisher.makeSureItIsDrag = function (event, action, actionName) {
                if (typeof actionName === 'undefined') {
                    actionName = generateActionName();
                }

                /*
                 |-------------------------------------------------------------------------
                 | Break on mouse release */

                // Only perform the action if mouse was not released before.
                var wasMouseReleased = false;

                $body.on(generateEventName("mouseup", actionName), function (event) {
                    wasMouseReleased = true;
                });

                /*
                 |-------------------------------------------------------------------------
                 | Distance moved */
                var originalX = event.pageX;
                var originalY = event.pageY;

                // We consider the movement a drag if either the user moves the mouse while it is pressed TODO OR if he holds it down for long enough
                $body.on(generateEventName("mousemove", actionName), function (event) {

                    // Jabr: We could use the proper check for circle here
                    // ( (Math.pow(originalX - event.pageX, 2) + Math.pow(originalY - event.pageY, 2) ) < Math.pow(MIN_DISTANCE_TO_BE_DRAG, 2))
                    // But I think that would be unnecessarily slow.
                    if ((Math.abs(originalX - event.pageX) + Math.abs(originalY - event.pageY)) > MIN_DISTANCE_TO_BE_DRAG) {
                        if (wasMouseReleased === false) {
                            considerItADrag(action, event, actionName);
                        }
                    }
                });

                // /*
                //  |-------------------------------------------------------------------------
                //  | Time pressed */
                // setTimeout(function () {
                //     if(wasMouseReleased === false) {
                //         considerItADrag(action, event, actionName);
                //     }
                // }, TIME_TO_BE_CONSIDERED_DRAG);


                return actionName;
            };

            /**
             * Whether the action currently being performed by the user is a mouse drag.
             * @memberOf Lfl.Events.ClickVsDragDistinguisher
             * @return boolean
             */
            ClickVsDragDistinguisher.isCurrentBehaviourDrag = function () {
                return isCurrentBehaviourDrag;
            };


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function removeMousemoveListener(actionName) {
                $('body').off(generateEventName("mousemove", actionName));
            }

            // We dont have a removeMouseupListener method, because the mouseup listener can be both on body or the element depending on desired behaviour.

            /**
             * Performs the actions assigned with finding out that the behaviour currently performed by the user is a
             * mouse drag.
             *
             * @param action
             * @param event
             * @param actionName
             */
            function considerItADrag(action, event, actionName) {
                isCurrentBehaviourDrag = true;

                removeMousemoveListener(actionName);
                $body.off(generateEventName("mouseup", actionName));
                action(event);

                $body.on(generateEventName("mouseup", actionName), function (event) {
                    $body.off(generateEventName("mouseup", actionName));
                    isCurrentBehaviourDrag = false;
                    }
                );
            }

            /*
             |-------------------------------------------------------------------------
             | Naming */

            function generateEventName(eventName, actionName) {
                return Lfl.Events.NamesGenerator.generateEventName(eventName, ".lfl.clickNoDrag.", actionName);

            }

            function generateActionName() {
                return Lfl.Events.NamesGenerator.generateActionName('onClickNotDrag');
            }

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Self-init
             |-------------------------------------------------------------------------------------------------------------------
             */

            // We need the isCurrentBehaviourDrag to be properly set, no matter where the user clicked on the screen.
            ClickVsDragDistinguisher.registerOnClickButNotDragAction({
                $element: $body,
                action: function () {/*Do nothing, just trigger the is current behaviour drag.*/
                }
            });

        }(Events.ClickVsDragDistinguisher = Events.ClickVsDragDistinguisher || {}, jQuery));
    }(Lfl.Events = Lfl.Events || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));